import {
    OPEN_ADD_SPECIMEN_LOCATION_MODAL,
    CLOSE_ADD_SPECIMEN_LOCATION_MODAL
} from './../config/actionTypes';

const initState = {
    addSpecimenLocationModalIsOpen: false
}

const specimenLocationsReducer = (state = initState, action) => {
    switch (action.type) {
        case OPEN_ADD_SPECIMEN_LOCATION_MODAL:
            return {...state, addSpecimenLocationModalIsOpen: true}

        case CLOSE_ADD_SPECIMEN_LOCATION_MODAL:
            return {...state, addSpecimenLocationModalIsOpen: false}

        default:
            return state
    }
};

export default specimenLocationsReducer;